import React, { Component } from "react";
import {
  profile,
  toFixed,
  format_date,
  GET,
  loading,
  params,
  MonthPicker,
  Navbar,
  XLSX,
  saveAs,
} from "../../components/CustomComponent.js";
export default class Settlements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_date: format_date(new Date(), "yyyy-mm", "en"),
      filter_currency: "THB",
      date: "",

      data: [],
      count: 10,
      loaded: false,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(0);
  }
  Get = async (page) => {
    let data, count;

    const { filter_date, filter_currency } = this.state;
    loading(true);
    let _date = new Date(filter_date);
    let _date_start = format_date(
      new Date(_date.getFullYear(), _date.getMonth(), 1),
      "yyyy-MM-dd",
      "en"
    );
    let _date_end = format_date(
      new Date(_date.getFullYear(), _date.getMonth() + 1, 0),
      "yyyy-MM-dd",
      "en"
    );

    let [result] = await Promise.all([
      GET("profits/settlements", {
        page_size: 100000,
        page: 0,
        data_search: "",
        start_date: filter_date
          ? format_date(_date_start, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_date ? format_date(_date_end, "yyyy-mm-dd", "en") : "",
        currency: filter_currency || "",
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data: data.filter((e) => e.broker?.uid === profile?.broker?.uid),
      count,
      date: _date,
      loaded: true,
    });
    loading(false);
  };

  ExportCSV = async () => {
    const { data, filter_date } = this.state;
    // EXPORT EXCEL
    const json_data = data.map((item) => ({
      Date: format_date(item.date),
      Previous: item.previous ? toFixed(item.previous, 2) : "00.00",
      Deposit: item.total_deposits ? toFixed(item.total_deposits, 2) : "00.00",
      Withdrawal: item.total_withdrawals
        ? toFixed(item.total_withdrawals, 2)
        : "00.00",
      Balance: item.balance ? toFixed(item.balance, 2) : "00.00",
    }));
    // 1. Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(json_data);

    // 2. Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // 3. Write the workbook to binary buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // 4. Save to file
    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(file, `settlements-${format_date(filter_date, "mm/yy", "en")}.xlsx`);
  };
  render() {
    const { filter_date, filter_currency, data, loaded } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const cell = (v) => (v ? toFixed(v, 2) : "00.00");
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Broker</div>
                <h2 className="ar-title mb-1">Settlement Reports</h2>
                <div className="ar-subtitle">
                  Daily settlement and balance tracking
                </div>
              </div>
<div className="ar-hero-actions">
                <button
                  className="ar-btn-ghost"
                  onClick={async () => {
                    this.ExportCSV();
                  }}
                >
                  <span className="icon me-2">{"\uf019"}</span>Export CSV
                </button>
</div>
</div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Month</span>
                  <MonthPicker
                    className="form-control"
                    placeholder="Month..."
                    onChange={(e) => {
                      this.setState({ filter_date: e });
                    }}
                    value={filter_date}
                  />
                </div>
                <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_date: format_date(new Date(), "yyyy-mm", "en"),
                        filter_currency: "THB",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
                </div>
              </div>
              <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">Daily Settlements</div>
              </div>
              <div className="d-none d-md-flex align-items-center gap-3 ar-legend">
                <span><i className="ar-legend-dot ar-legend-dep"></i>Deposit</span>
                <span><i className="ar-legend-dot ar-legend-wd"></i>Withdrawal</span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table">
                <thead>
                  <tr>
                    <td className="text-nowrap">Date</td>
                    <td className="text-nowrap text-end">Previous</td>
                    <td className="text-nowrap text-end ar-group-start">Deposit</td>
                    <td className="text-nowrap text-end">Withdrawal</td>
                    <td className="text-nowrap text-end ar-group-start ar-head-profit">Balance</td>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => {
                    const d = new Date(item.date);
                    const day = isNaN(d) ? "" : String(d.getDate()).padStart(2, "0");
                    return (
                      <tr key={`array-${index}`}>
                        <td data-label="Date" className="text-nowrap">
                          <div className="ar-month-badge">
                            <span>{day}</span>
                            {format_date(item.date)}
                          </div>
                        </td>
                        <td data-label="Previous" className="text-nowrap text-end ar-muted">
                          {cell(item.previous)}
                        </td>
                        <td
                          data-label="Deposit"
                          className={`text-nowrap text-end ar-group-start ${
                            Number(item.total_deposits) > 0 ? "ar-dep-profit" : "ar-zero"
                          }`}
                        >
                          {cell(item.total_deposits)}
                        </td>
                        <td
                          data-label="Withdrawal"
                          className={`text-nowrap text-end ${
                            Number(item.total_withdrawals) > 0 ? "ar-wd-profit" : "ar-zero"
                          }`}
                        >
                          {cell(item.total_withdrawals)}
                        </td>
                        <td
                          data-label="Balance"
                          className={`text-nowrap text-end ar-group-start fw-bold ${
                            Number(item.balance) < 0 ? "ar-neg" : ""
                          }`}
                        >
                          {cell(item.balance)}
                        </td>
                      </tr>
                    );
                  })}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={5} className="text-center py-5">
                        <div className="ar-empty">No data</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
